import { render, staticRenderFns } from "./EditTestForm.vue?vue&type=template&id=98bbf3c8&"
import script from "./EditTestForm.vue?vue&type=script&lang=js&"
export * from "./EditTestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports